module.exports = __webpack_public_path__ + "img/star-fill.39a70cc2.svg";